<template>
  <div>
    <div v-if="!show_giggle_redirect">      
      <h3>Business Information</h3>
      <Input
        @enter="next"
        :inputField="inputs.name"
        inputName="Legal Business Name"
        inputType="name"
      />
      <!-- <label class="label">Business Start Date</label> -->
      <!-- <div class="business_start_date_container">
        <Dropdown
          :inputField="inputs.startMonth"
          :options="monthOptions"
          inputName=""
          inputType="string"
        />
        <Input
          @enter="next"
          :inputField="inputs.startYear"
          inputName=""
          inputType="year"
          placeholder=" ex. 1990"
        />
      </div> -->
      <List
        :inputField="inputs.years_in_business"
        :options="years_in_biz_options"
        inputName="Years in Business"
        inputId="years_in_business"
        :fullWidthOption="false"
      />
      <List
        :inputField="inputs.classification"
        :options="classificationOptions"
        inputName="Business Classification"
        inputId="classification"
        :fullWidthOption="false"
      />
      <Input v-if="!show_alternative_ssn"
        @enter="next"
        :inputField="inputs.tid"
        inputName="Business Federal Tax ID (EIN)"
        placeholder="XX-XXXXXXX"
        inputType="ein"
        obj="business"
      />
      <Input v-if="show_alternative_ssn"
        @enter="next"
        :inputField="inputs.tid"
        inputName="Social Security Number"
        placeholder="XXX-XX-XXXX"
        inputType="ssn"
        obj="business"
      />
      
      <Dropdown
        v-show="show_job_title == true"
        @enter="next"
        :inputField="inputs.title"
        inputName="Your Job Title"
        inputType="string"
        :options="titleOptions"
      />

      <SmallCheckbox
        :inputField="inputs.home_based_business"
        inputName="Home Based Business?"
        inputType="string"
      />
      <Dropdown
        :inputField="inputs.general_industry"
        :options="generalIndustryOptions"
        inputName="Industry"
        inputType="string"
      />
      <!-- <Dropdown
        :inputField="inputs.industry"
        :options="industryOptions"
        inputName="Industry"
        inputType="string"
      /> -->
      <AddressInput
        :inputField="inputs.address"
        inputName="Physical Business Address (No P.O. Boxes)"
        inputType="string"
        @selectedAddress="updateAddress"
      />
      <i
        v-show="selected_address == true"
        class="address_selected fas fa-check"
      ></i
      >&nbsp;
      <i
        v-show="selected_address == false"
        class="address_selected"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="14" viewBox="0 0 11 14" fill="none">
          <path d="M5.69565 13C5.69565 13 10.3913 8.82609 10.3913 5.69565C10.3913 3.10231 8.28899 1 5.69565 1C3.10232 1 1 3.10231 1 5.69565C1 8.82609 5.69565 13 5.69565 13Z" stroke="#999999"/>
          <path d="M7.19585 5.5001C7.19585 6.32852 6.52427 7.0001 5.69585 7.0001C4.86742 7.0001 4.19584 6.32852 4.19584 5.5001C4.19584 4.67167 4.86742 4.0001 5.69585 4.0001C6.52427 4.0001 7.19585 4.67167 7.19585 5.5001Z" stroke="#999999"/>
        </svg>
      </i>&nbsp; <label class="label full_address">{{ full_address }}</label>&nbsp;
      <a class="toggle_address" href="javascript:void(0)" @click="toggleAddressFields" role="button">
        Or enter address manually
      </a>
      <Input
        @enter="next"
        :inputField="inputs.city"
        inputName="City"
        inputType="string"
        ref="city"
        autocomplete="address-level2"
        v-show="show_address_fields == true"
      />
      <div id="state_container" v-show="show_address_fields == true">
        <Input
          @enter="next"
          :inputField="inputs.state"
          inputName="State"
          inputType="state"
          ref="state"
          autocomplete="address-level1"
          v-show="show_address_fields == true"
        />
        <Input
          @enter="next"
          :inputField="inputs.zip"
          inputName="Zip Code"
          inputType="zip"
          ref="zip"
          autocomplete="postal-code"
          v-show="show_address_fields == true"
        />
      </div>
      <Input
        @enter="next"
        :inputField="inputs.website"
        inputName="Business Website or Social Media Page"
        inputType="string_empty"
        :icons="{ left: 'fa-globe' }"
      />
      <!-- <Input
        :inputField="inputs.justification"
        inputName="Provide a brief description of what your business does."
        inputType="string"
      /> -->
      <!-- <Choices
        :inputField="inputs.loanuse"
        inputName="What will your business be using the loan for?"
        :options="[
          'Inventory',
          'Second Location',
          'Payroll',
          'Equipment Purchase',
          'Supplies',
          'Loan Consolidation',
        ]"
      /> -->
      <div class="buttons is-right">
        <!-- <a class="button is-link is-inverted padded-button next-button">Skip</a> -->
        <a class="button is-link padded-button next-button continue-button" @click="next"
          >Continue</a
        >
      </div>
    </div>
    <div v-else id="giggle_container">
      <div>
        <img
          src="../../../../src/assets/img/logo_cardiff_giggle.png"
          id=""
          height="47"
          width="216"
          defer
        />
      </div>
      <div id="giggle_x_image">
        <img
          src="../../../../src/assets/img/giggle_x.png"
          id=""
          height="32"
          width="32"
          defer
        />
      </div>
      <div id="giggle_logo">
        <img
          src="../../../../src/assets/img/giggle_logo.png"
          id=""
          height="61"
          width="216"
          defer
        />
      </div>
      <div id="giggle_text">
        <b>Cardiff</b> is partnering with<br/> 
        <b>Giggle Finance</b> to offer<br/>
        you an immediate funding option!
      </div>
      <a :href="giggle_url" id="giggle_cta" class="button is-link" :class="{ disabled: !leadid_loaded }">LET'S GO!</a> 
      <p id="giggle_terms_container">
        By continuing you agree to Giggle's <br/><a id="cta_link" href="https://gigglefinance.com/terms/" target="_blank">Terms and Conditions</a>
      </p>
    </div>
  </div>
</template>

<script>
import Input from "@/components/shared/Input";
import Dropdown from "@/components/shared/Dropdown";
import ApplyPage from "@/components/shared/ApplyPage";
import List from "@/components/shared/List";
import AddressInput from "@/components/shared/AddressInput";
// import Choices from "@/components/shared/Choices";
import SmallCheckbox from "@/components/shared/SmallCheckbox";
import MyUtils from "@/utils/MyUtils";
export default {
  name: "BusinessInfo",
  components: {
    Input,
    Dropdown,
    AddressInput,
    List,
    SmallCheckbox
  },
  mixins: [ApplyPage],
  data() {
    return {
      obj: "business",
      inputs: {
        name: Input.model(),
        startMonth: Input.model(),
        startMonthNumber: 1,
        startYear: Input.model(),
        years_in_business: Input.model(),
        tid: Input.model(),
        classification: Input.model(),
        title: Input.model(),
        general_industry: Input.model(),
        industry: Input.model(),
        address: AddressInput.model(),
        city: Input.model(),
        state: Input.model(),
        zip: Input.model(),
        website: Input.model(),
        // securing_financing: Input.model(),
        home_based_business: Input.model()
        // justification: Input.model(),
        // loanuse: Input.model(),
      },
      years_in_biz_options: [
        "0-1 year",
        "1-2 years",
        "2-5 years",
        "5+ years"
      ],
      monthOptions: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      industryOptions: [
        "Accounting",
        "Agriculture",
        "Alarm Company",
        "Automobile",
        "Auto Repair",
        "Automobile Sales",
        "Business Services",
        "Car Service/Limousine",
        "Chiropractic Treatment",
        "Clothing Store",
        "Computer/Electronics",
        "Consumer Services",
        "Convenient Store",
        "Construction",
        "Daycare",
        "Delivery service/Local",
        "Dry cleaners",
        "E-Commerce",
        "Education",
        "Electrician/Electrical Work",
        "Energy",
        "Excavating",
        "Facility Maintenance/Cleaning",
        "Financial Services",
        "Flooring",
        "Food Service",
        "Funeral Home/Cremation Services",
        "Government",
        "Grocery Store",
        "Gym",
        "Handyman/Repair",
        "HVAC",
        "Health/Pharmaceuticals",
        "Health/Fitness/Spa",
        "Home Care/Treatment Facility",
        "Hospitality",
        "IT Services",
        "Landscaping",
        "Lawyer/Attorney",
        "Liquor Store",
        "Manufacturing",
        "Marketing Firm/Public Relations",
        "Mining",
        "Media/Entertainment",
        "Medical/Dental",
        "Moving Company",
        "Non-Profit",
        "Oil And Gas",
        "Painter",
        "Pest Control",
        "Pet Care",
        "Plumbing/Heating",
        "Pool Design/Driveway/Paving",
        "Property Management",
        "Real Estate",
        "Restaurant",
        "Retail",
        "Roofing",
        "Staffing/HR Services",
        "Security Service",
        "Software/Internet",
        "Spa/Salon",
        "Storage/Containers",
        "Telecommunications",
        "Towing",
        "Training/Sports Recruitment",
        "Transportation",
        "Travel/Leisure",
        "Utilities",
        "Vape Shop/Tobacco Shop",
        "Wholesale/Distribution",
        "Welding",
        "Wildlife Preservation/Fire Safety",
        "Window/Garage/Paving Installation",
        "Window Cleaning /Pressure Washing",
        "Other",
      ],
      classificationOptions: [
        "Partnership",
        "LLC",
        "Corporation",
        "Sole Proprietorship",
      ],
      generalIndustryOptions: [
        "Retail",
        "Restaurants and Food Services",
        "Healthcare",
        "Hospitality",
        "Automotive",
        "Professional Services",
        "Construction and Contracting",
        "Beauty and Wellness",
        "E-commerce",
        "Manufacturing",
        "Transportation and Logistics",
        "Education and Childcare",
        "Real Estate",
        "Technology",
        "Wholesale",
        "Non-profits",
        "Auto Sales",
        "Other Services",
      ],
      titleOptions: [
        "Administrator",
        "CEO",
        "COO",
        "Co-Owner",
        "Director",
        "Founder",
        "General Manager",
        "Owner",
        "Manager",
        "Managing Member",
        "Member",
        "President",
        "Partner",
        "Other",
      ],
      show_job_title: false,
      show_address_fields: false,
      selected_address: false,
      full_address : '',
      show_alternative_ssn: false,
      show_giggle_redirect : false,
      leadid_loaded : false,
      giggle_url :'',
      leadid_load_attempts : 0
    };
  },
  mounted: function () {
    let self = this;
    
    $('#Partnership,#LLC,#Corporation').on( "click",function(){
      self.show_alternative_ssn = false;
    });
    $('#Sole_Proprietorship').on( "click",function(){
      self.show_alternative_ssn = true;
    });
    console.log("triggering contact form");
    this.$gtm.trackEvent({
      event: "contact_form",
      // category: 'Contact Form',
      // action: 'click',
      // label: 'Contact Form Complete',
      // value: 5000
    });
  },
  created: function () {
    console.log('created..');
    let monthly_sales = MyUtils.getWithExpiry('monthly_sales');
    let monthly_sales_float = 0;
    if (monthly_sales && typeof monthly_sales ==='string' && monthly_sales != "") {
      monthly_sales_float = parseFloat(monthly_sales.replace(/,/g, ""));
    } else if (monthly_sales && typeof monthly_sales ==='number' && monthly_sales != "") {
      monthly_sales_float = monthly_sales;
    }
    console.log('monthly_sales_float',monthly_sales_float);
    if(monthly_sales_float < 20000){
      this.show_giggle_redirect = true;
    }
    this.checkLeadid();

  },
  methods: {
    checkLeadid: function(){
      console.log('check leadid');
      let self = this;
      if(!self.show_giggle_redirect){
        console.log('show_giggle_redirect false');
        return false;
      }
      const interval = 500; // seconds
      async function fetchUpdates() {
        let giggle_utm = '';
        console.log('fetch update');
        self.leadid_load_attempts++;
        console.log('attempt: ', self.leadid_load_attempts);

        let first_name = MyUtils.getWithExpiry('first_name');
        if(first_name){
          giggle_utm = giggle_utm + "firstname=" + first_name + '&';
        }
        let last_name = MyUtils.getWithExpiry('last_name');
        if(last_name){
          giggle_utm = giggle_utm + "lastname=" + last_name + '&';
        }
        let phone = MyUtils.getWithExpiry('phone_number');
        if(phone){
          giggle_utm = giggle_utm + "phone=" + phone + '&';
        }
        let email = MyUtils.getWithExpiry('email');
        if(email){
          giggle_utm = giggle_utm + "email=" + email + '&';
        }


        let leadid = MyUtils.getWithExpiry('leadid');
        console.log('leadid:', leadid);
        if(leadid){
          giggle_utm = giggle_utm + "leadId=" + leadid + '&';
          self.giggle_url = 'https://beta.gigglefinance.com/partner/init?' + giggle_utm +'partnerId=2949';
          console.log('giggle utm:',giggle_utm);
          self.leadid_loaded = true;
        }else{
          if(self.leadid_load_attempts>=100){
            return false;
          }else{
            console.log('not found, running fetch update again');
            setTimeout(fetchUpdates, interval);
          } 
        }
      }
      fetchUpdates();
    },
    getIndustry: function (general_industry_selected) {
      let new_industries = [];
      switch (general_industry_selected) {
        case "Retail":
          new_industries = ['Clothing Stores', 'Electronics Stores', 'Furniture Stores','Grocery Stores','Auto Parts Store', 'Jewelry', 'Specialty Stores' ]
          break;
        case "Restaurants and Food Services":
          new_industries = ['Fast Food', 'Fine Dining', 'Cafes','Food Trucks','Catering Services','Desserts', 'Bakery'];
          break;
        case "Healthcare":
          new_industries = ['Medical Practice','Dental Practice','Veterinary Clinic','Physical Therapy','Home Healthcare Services','Specialty Clinic','Mental Health Service'];
          break;
        case "Hospitality":
          new_industries = ["Hotels", "Motels", "Bed and Breakfasts", "Event Venues"];
          break;
        case "Automotive":
          new_industries = ["Car Dealerships", "Automotive Repair", "Automotive Other"];
          break;
        case "Professional Services":
          new_industries = ["Legal Services", "Accounting and Bookkeeping", "Consulting Firm", "Marketing Services", "HR Services", "Financial Advisory"];
          break;
        case "Construction and Contracting":
          new_industries = ["General Contractor", "Home Renovation", "Landscaping", "Excavation", "Homebuilder", "Home Improvement", "Roofing", "Mining", "Lumber and Wood", "Painter", "HVAC", "Plumbing", "Electrician", "Stone/Granite Countertops", "Flooring", "Paving/Sealing/Concrete", "Other Specialty Trade Contractors"];
          break;
        case "Beauty and Wellness":
          new_industries = ["Salons", "Barber", "Spas", "Gym", "Yoga Studio", "Massage Parlor", "Med Spa"];
          break;
        case "E-commerce":
          new_industries = ["Online Retailers", "Subscription Services", "Marketplace"];
          break;
        case "Manufacturing":
         new_industries = ["Manufacturing"];
          break;
        case "Transportation and Logistics":
          new_industries = ["Long Haul Trucking", "Local Trucking", "Towing", "Non Emergency Medical Transportation", "Logistics Services", "Moving and Storage", "Passenger Transportation"];
          break;
        case "Education and Childcare":
          new_industries = ["Private Schools", "Daycare Centers", "Tutoring Services"];
          break;
        case "Real Estate":
          new_industries = ["Property Management", "Real Estate Brokers", "Mortgage Brokers", "Real Estate Fix/Flip", "Title Services", "Inspection Services", "Appraisal Services"];
          break;
        case "Technology":
          new_industries = ["IT Services", "Software Development Firms", "Consulting"];
          break;
        case "Wholesale":
          new_industries = ["Wholesale", "Bulk Supplier", "Import/Export"];
          break;
        case "Non-profits":
          new_industries = ["Non-profit"];
          break;
        case "Other Services":
          new_industries = ["Pet Grooming", "Pet Boarding", "Residential Cleaning", "Janitorial Services", "Waste Management", "Tattoo Parlor", "Funeral Homes", "Staffing/Recruiting", "Event Planning", "Entertainment Production", "Photography/Videography", "Carwash", "Dry Cleaning", "Travel Agency", "Security Services", "Personal Training", "Sports and Recreation", "Other Services"];
          break;
        default:
        break;
      }
      return new_industries;
    },
    updateAddress: function (data) {
      console.log(data);
      this.inputs.city.value = data.city;
      this.inputs.state.value = data.state;
      this.inputs.zip.value = data.zip;
      if (
        data.city &&
        data.city !== "" &&
        data.state &&
        data.state !== "" &&
        data.zip &&
        data.zip !== ""
      ) {
        console.log('changing..')
        // this.show_address_fields = false;
        this.selected_address = true;
        this.full_address =
          data.street_number +
          " " +
          data.street +
          ", " +
          data.city +
          ", " +
          data.state +
          ", " +
          data.zip;
      }
    },
    toggleAddressFields: function () {
      this.show_address_fields = !this.show_address_fields;
    },
    getDateSubtractingMonths: function (months) {
    // Get the current date
      const currentDate = new Date();
      // Subtract the specified number of months
      currentDate.setMonth(currentDate.getMonth() - months);
      // Extract the full month name
      const month = currentDate.toLocaleString('en-US', { month: 'long' });
      // Extract the 4-digit year
      const year = currentDate.getFullYear();
      const month_index = currentDate.getMonth();
      return { month, year, month_index };
    }
  },
  watch: {
    inputs: {
      deep: true,
      handler(newValue, oldvalue) {
        // console.log("new value",newValue);
        // if (newValue.general_industry.value != "") {
        //   this.industryOptions =  this.getIndustry(newValue.general_industry.value);
        // }

        if (newValue.classification.value != "") {
          let selected_classification = newValue.classification.value;
          if (selected_classification === "Sole Proprietorship") {
            this.inputs.title.value = "Owner";
          } else if (selected_classification === "Partnership") {
            this.inputs.title.value = "Partner";
          } else if (selected_classification === "LLC") {
            this.inputs.title.value = "Managing Member";
          } else if (
            selected_classification === "C Corporation" ||
            selected_classification === "S Corporation"
          ) {
            this.inputs.title.value = "President";
          } else {
            this.inputs.title.value = "Owner";
          }
          // this.show_job_title = false;
          // if (this.toggle_job_title) {
          //   this.show_job_title = this.toggle_job_title;
          // }
        }

        if (newValue.years_in_business.value != "") {
          let value = newValue.years_in_business.value;
          let month = '';
          let year = '';
          let month_index = '';
          if(value === '0-1 year'){
            let res  = this.getDateSubtractingMonths(6);
            month = res.month;
            year = res.year;
            month_index = res.month_index;
          }else if(value === "1-2 years"){
            let res  = this.getDateSubtractingMonths(12);
            month = res.month;
            year = res.year;
            month_index = res.month_index;
          }else if(value === "2-5 years"){
            let res  = this.getDateSubtractingMonths(24);
            month = res.month;
            year = res.year;
            month_index = res.month_index;
          }else if(value === "5+ years"){
            let res  = this.getDateSubtractingMonths(60);
            month = res.month;
            year = res.year;
            month_index = res.month_index;
          }
          // console.log("month:" + month);
          // console.log("year:" + year);
          // console.log("month_index:" + month_index);
          this.inputs.startMonth.value = month;
          this.inputs.startYear.value  = year;
          this.inputs.startMonthNumber  = month_index;
        }
      //  this.other_selected = false;

      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.business_start_date_container{
  display: inline-flex;
}
.business_start_date_container .field:first-child{
  width: 49%;
  padding-right: 5%;
}
.business_start_date_container .field:nth-child(2){
  width: 49%;
}
#state_container{
  display: inline-flex;
  width: 100%;
}
#state_container div{
  width: 50%;
  margin-right: 10px;
}

/* start google address */
.full_address {
  color: gray;
  display: inline-block;
  margin-bottom: 10px;
}
.toggle_address {
  /* color: #666; */
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
}
#giggle_container{
  text-align: center;
  margin-top: 43px;
}
#giggle_logo{
  margin-bottom: 75px;
}
#giggle_cta{
  background-color: #FD5196;
  border: none;
  color: #FFF;
  text-align: center;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  width: 352px;
  height: 53px;
  border-radius: 0;
  margin: 0 auto;
}
#giggle_cta a{
  color: #FFF;
}
.disabled {
  pointer-events: none; /* Disable clicks */
  opacity: 0.5; /* Visual cue */
}
#giggle_x_image{
  margin-top: 24px;
  margin-bottom: 24px;
}
#giggle_text{
  color: #000;
  text-align: center;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  /* font-weight: 700; */
  line-height: normal;
  margin-bottom: 40px;
}
#giggle_terms_container{
  margin-top: 24px;
}
@media (max-width: 80em) {
  .full_address {
    margin-bottom: 0px;
  }
  .toggle_address {
    margin-bottom: 18px;
    display: inline-block;
  }
}
@media (max-width: 47.999em) {
  .full_address {
    margin-bottom: 0px;
  }
  .toggle_address {
    margin-bottom: 18px;
    display: inline-block;
  }
}
.address_selected {
  color: green;
}
/* end google address */
</style>